import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { CreatePresignedUrlForBulkUploadRequest, CreatePresignedUrlForBulkUploadResponse } from "@maven-rest/docs/S3.dto";
import { S3Url } from "@maven-rest/docs/S3.url";

export function useCreatePresignedPostUrlBulkMutation(
  options?: SimpleMutationOptions<CreatePresignedUrlForBulkUploadResponse, CreatePresignedUrlForBulkUploadRequest>
) {
  return useBaseMutation({
    fnOption: { url: S3Url.createPresignedUrlForBulkUpload },
    ...options,
  });
}
